import gql from 'graphql-tag';

export default gql`
  fragment stageChangeProspectActivityFragment on StageChangeProspectActivity {
    stage
    stageText
  }
`;
